import { Component, Vue } from "vue-facing-decorator";

@Component({
    name: "ServiceViewComponent",
})
export default class ServiceViewComponent extends Vue {}
